module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0id2hpdGUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS42MzEgMS42MzJMMTQuNTAxIDAuNUw4LjA2NiA2LjkzNUwxLjYzMiAwLjVMMC41IDEuNjMyTDYuOTM1IDguMDY2TDAuNSAxNC41MDFMMS42MzIgMTUuNjMxTDguMDY2IDkuMTk3TDE0LjUwMSAxNS42MzFMMTUuNjMxIDE0LjUwMUw5LjE5NyA4LjA2NkwxNS42MzEgMS42MzJaIi8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// /tmp/build_83f21ab6/src/assets/images/close-icon.svg
// module id = 822
// module chunks = 0 1 2 3 4